import { ManualNbrDTOV2 } from '../../api'

export default class AddManualNbrDTO implements ManualNbrDTOV2 {
  clientOid: string;
  adviserOid: string;
  lineOfBusiness: string;
  applicationDate: number;
  mainNbrOid?: string;
}
